import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useStoreCatalog, StoreCatalog } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<StoreCatalog>
    useData={useStoreCatalog}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
